import * as yup from 'yup';

import {
	PROMPT_IS_DEFAULT,
	PROMPT_IS_MUST_BE,
	PROMPT_TEXT_REQUIRED,
	PROMPT_TITLE_REQUIRED,
} from './prompt-schema.errors';

export const promptSchema = yup.object({
	title: yup.string().required(PROMPT_TITLE_REQUIRED),
	text: yup.string().required(PROMPT_TEXT_REQUIRED),
	isDefault: yup
		.string()
		.oneOf(['Yes', 'No'], PROMPT_IS_MUST_BE)
		.required(PROMPT_IS_DEFAULT),
});
